import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import { isEnterOrSpace } from '@Utils/KeyboardUtil';

/* eslint-disable react-hooks/exhaustive-deps */
function RsSlidablePaginatedNavigation({ prevDisabled, nextDisabled, goPrev, goNext, isLoading }) {
  const [nextIntervalId, setNextIntervalId] = useState(0);
  const [prevIntervalId, setPrevIntervalId] = useState(0);
  const [isKeyPressed, setIsKeyPressed] = useState(false);

  const handleNextStart = () => {
    goNext();
    let newIntervalId = setTimeout(function tick() {
      goNext();
      newIntervalId = setTimeout(tick, 400); // (*)
      setNextIntervalId(newIntervalId);
    }, 400);
    setNextIntervalId(newIntervalId);
  };

  const handleNextStop = () => {
    clearTimeout(nextIntervalId);
    setNextIntervalId(0);
  };

  const handlePrevStart = () => {
    goPrev();
    let newIntervalId = setTimeout(function tick() {
      goPrev();
      newIntervalId = setTimeout(tick, 400); // (*)
      setPrevIntervalId(newIntervalId);
    }, 400);
    setPrevIntervalId(newIntervalId);
  };

  const handlePrevStop = () => {
    clearTimeout(prevIntervalId);
    setPrevIntervalId(0);
  };

  useEffect(() => {
    if (nextDisabled) {
      clearTimeout(nextIntervalId);
      setNextIntervalId(0);
    }
    if (prevDisabled) {
      clearTimeout(prevIntervalId);
      setPrevIntervalId(0);
    }
    if (isLoading) {
      clearTimeout(nextIntervalId);
      clearTimeout(prevIntervalId);
      setNextIntervalId(0);
      setPrevIntervalId(0);
    }
  }, [prevDisabled, nextDisabled, isLoading]);

  return (
    <div className="rs-slidable-navigation">
      <Button
        onMouseDown={handlePrevStart}
        onKeyDown={(e) => {
          if (isEnterOrSpace(e) && !isKeyPressed) {
            setIsKeyPressed(true);
            handlePrevStart();
          }
        }}
        onMouseUp={handlePrevStop}
        onKeyUp={() => {
          handlePrevStop();
          setIsKeyPressed(false);
        }}
        disabled={prevDisabled}
        buttonConfig={{
          className: 'rs-slidable-navigation__button',
          type: 'link',
          size: 'sm',
          iconOnly: true,
          ariaLabel: 'Slide previous',
          e2eName: 'slide-left',
        }}
        iconConfig={{ name: 'chevron-left', size: 'sm' }}
      />
      <Button
        onMouseDown={handleNextStart}
        onKeyDown={(e) => {
          if (isEnterOrSpace(e) && !isKeyPressed) {
            setIsKeyPressed(true);
            handleNextStart();
          }
        }}
        onMouseUp={handleNextStop}
        onKeyUp={() => {
          handleNextStop();
          setIsKeyPressed(false);
        }}
        disabled={nextDisabled}
        buttonConfig={{
          className: 'rs-slidable-navigation__button',
          type: 'link',
          size: 'sm',
          iconOnly: true,
          ariaLabel: 'Slide next',
          e2eName: 'slide-right',
        }}
        iconConfig={{ name: 'chevron-right', size: 'sm' }}
      />
    </div>
  );
}

RsSlidablePaginatedNavigation.propTypes = {
  prevDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  goPrev: PropTypes.func.isRequired,
  goNext: PropTypes.func.isRequired,
};

export default RsSlidablePaginatedNavigation;
